module.exports = "img/flags/GS.6e92918.png";